
const storage = {
	get(settingsKey) {
		const settings = localStorage.getItem(settingsKey);

		return settings ? JSON.parse(settings) : {};
	},

	save(settingsKey, settings, merge = false) {
		if (merge) {
			settings = Object.assign(
				this.get(settingsKey),
				settings,
			);
		}

		localStorage.setItem(settingsKey, JSON.stringify(settings));

		return this.get(settingsKey);
	},
};

export default storage;
